import { fg_onEmphasis } from "@clockwise/design-system/tokens";
import classNames from "classnames";
import { Lightbulb } from "phosphor-react";
import React, { HTMLAttributes } from "react";
import {
  bg_calOwn_Emphasis,
  border_calDeemphasis,
  fg_calDeemphasis,
  fg_calOwn,
} from "../../../constants/calendarColorTokens";
import { CalendarColorSet } from "../../../util/calendar-coloring";

type CalendarHoldProps = HTMLAttributes<HTMLDivElement> & {
  calendarColorSet: CalendarColorSet;
  deemphasis: boolean;
  fade?: boolean;
  subtext?: string;
  text: string;
};

export const CalendarHold = ({
  calendarColorSet,
  deemphasis,
  fade = false,
  onClick,
  subtext,
  text,
}: CalendarHoldProps) => {
  let bg_color = border_calDeemphasis;
  let fg_color = fg_calDeemphasis;

  if (!deemphasis) {
    // defensive codeing required as we are missing typesafety in a Planner consumer
    bg_color = calendarColorSet?.bg_Emphasis || bg_calOwn_Emphasis;
    fg_color = calendarColorSet?.fg || fg_calOwn;
  }

  return (
    <div
      className={classNames(
        "cw-absolute cw-left-[1px]",
        "cw-h-full cw-w-full",
        "cw-flex cw-space-x-2 cw-group",
        "cw-cursor-pointer",
        { "cw-opacity-50": fade },
      )}
      onClick={onClick}
    >
      <div className="cw-relative">
        <div
          className="cw-h-full cw-w-[4px] cw-rounded-full cw-flex cw-items-center cw-justify-center"
          style={{ background: bg_color }}
        />
        <div
          className={classNames(
            "cw-absolute cw-top-0 cw-left-[-5px]",
            "cw-h-[14px] cw-w-[14px]",
            "cw-rounded-full",
            "cw-flex cw-items-center cw-justify-center",
          )}
          style={{ background: bg_color }}
        >
          <Lightbulb color={fg_onEmphasis} size={10} weight="fill" />
        </div>
      </div>
      <div
        className={classNames(
          "cw-pt-[2px] cw-body-base cw-leading-[13px] cw-text-[12px] cw-font-medium",
          "cw-hidden group-hover:cw-block",
        )}
        style={{ color: fg_color }}
      >
        {text}
        <div className="cw-text-[11px]">{subtext}</div>
      </div>
    </div>
  );
};
